<div *ngIf="messages" class="messages">
  <div *ngFor="let message of messages" class="message-item">
    <div class="message-header">
      <div class="message-date">{{ message.createdDate | date }}</div>

      <h4 class="message-title">
        <a *ngIf="!message.moodleUrl" href="#">{{ message.fromSystem }}</a>
        <a *ngIf="message.moodleUrl" href="{{message.moodleUrl}}" target="_blank">{{ message.fromSystem }}</a>
      </h4>
    </div>
    <div class="message-content" *ngIf="message.message">{{ message.message }}</div>
  </div>
</div>

<div *ngIf="!messages">
  אין לך כרגע הודעות
</div>
